import { AppHelper } from "../../appHelper";
import { CommonApp, Context, Entity, Metadata } from "../../core/components/commonApp";
import { TaskGroupEntity } from "../../taskGroup/taskGroup";
import { Sheet, SheetEventType } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import { Helper } from "../../core/util/helper";
import { MetaDataHelper } from "../../core/util/metaDataHelper";
import { PageTitleProps } from "../../core/components/pageTitle";
import React from "react";
export default class ChangeTaskGroupPeriodApp extends React.Component<ChangeTaskGroupPeriodAppProps, any> {
    common = new AppHelper();
    sheet: Sheet;

    constructor(props: ChangeTaskGroupPeriodAppProps) {
        super(props);
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.sheet.bind(SheetEventType.Custom, (data: any) => {
            if (Helper.hasValue(data) && data.command === "reset") {
                this.handleFieldChange({ model: data.field }, null);
            }
        });
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        let prop = this.matchMergedProp(field.model);
        if (Helper.hasValue(prop)) {
            this.updateProp(prop, value);
        }
        else if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    matchMergedProp = (fieldName: string): string => {
        let match = fieldName.match(/^entity\.(?:MergedProps|ExplicitProps)\.(\w+)$/);
        if (Helper.hasValue(match))
            return match[1];
        else
            return null;
    }

    updateProp = (prop: string, value: any) => {
        this.common.handleFieldChange({ model: 'entity.ExplicitProps.' + prop }, value);
        let parentValue = MetaDataHelper.getFieldValue(this.props.entity, 'entity.ParentProps.' + prop);
        let mergedValue = value;
        if (Helper.isNullOrEmpty(value) && Helper.hasValue(parentValue))
            mergedValue = parentValue;
        this.common.handleFieldChange({ model: 'entity.MergedProps.' + prop }, mergedValue);
    }

    save = () => {
        if (this.common.validate())
            this.common.handlePostSave(true);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title,
        };
        return (<CommonApp {...props} titleProps={titleProps} />);
    }
}

export interface ChangeTaskGroupPeriodAppProps {
    entity: ChangeTaskGroupPeriodEntity;
    title: string;
    metadata: Metadata;
    context: Context;
}

export interface ChangeTaskGroupPeriodEntity extends Entity {
    ParentProps: TaskGroupEntity;
    ExplicitProps: TaskGroupEntity;
    MergedProps: TaskGroupEntity;
    Level: number;
    KeyData: KeyDataEntity;
}

export interface KeyDataEntity {
    MinStartsOn: number;
    MaxStartsOn: number;
    MaxEndsOn: number;
    MaxExecutionDate: number;
}